var COLORS = {
    WHITE: "#FFFFFF"
};

// Private:
var chart = {};

// Exported for use from React code
export function _initBarChart(canvasName, data, fontSize, onClickBar, suggestedMax, actualMax) {
    initBarChart(canvasName, data, fontSize, onClickBar, suggestedMax, actualMax);
}

export function _clearBarChart(canvasName){
    clear(canvasName);
}

function initBarChart(canvasName, data, fontSize, onClickBar, suggestedMax, actualMax) {

    // eslint-disable-next-line no-undef
    Chart.defaults.global.defaultFontFamily = 'Montserrat';

    // eslint-disable-next-line no-undef
    Chart.defaults.global.defaultFontColor = COLORS.WHITE;

    var canvas = null;

    if (typeof canvasName === 'string' || canvasName instanceof String) {
        canvas = document.getElementById(canvasName);
    }

    if ((undefined === canvas) || (null === canvas)) {
        console.log('init canvas NOT INITIALIZED', canvas);
        return;
    }

    if ((undefined === fontSize) || (null === fontSize)) {
        fontSize = 18;
    }

    var datasets = [];

    data.data.forEach(element => {

        var dataSet = {};
        dataSet.label = element.label;
        dataSet.backgroundColor = element.color;
        dataSet.borderColor = element.color;
        dataSet.borderWidth = 1;
        dataSet.data = element.values;

        datasets.push(dataSet);
    });

    const barChartData = {
        labels: data.xAxisGroupLabels,
        datasets: datasets
    };

    // eslint-disable-next-line no-undef
    Chart.Legend.prototype.afterFit = function () {
        this.height = this.height + 10;
    };

    // Fix to draw the right grid line
    // https://github.com/chartjs/Chart.js/issues/3804
    // eslint-disable-next-line no-undef
    Chart.plugins.register({
        beforeDraw: function (chart, easing) {
            var ctx = chart.chart.ctx;

            if (chart.config.type === 'bar') {
                //Save the rendering context state
                ctx.save();

                // eslint-disable-next-line no-undef
                ctx.strokeStyle = chart.config.options.scales.xAxes[0].gridLines.color || Chart.defaults.bar.scales.xAxes[0].gridLines.color || "rgba(220,220,220,0.8)";

                // eslint-disable-next-line no-undef
                ctx.lineWidth = chart.config.options.scales.xAxes[0].gridLines.lineWidth || Chart.defaults.bar.scales.xAxes[0].gridLines.lineWidth || 1;

                ctx.beginPath();
                ctx.moveTo(chart.chartArea.right, chart.chartArea.top);
                ctx.lineTo(chart.chartArea.right, chart.chartArea.bottom);
                ctx.stroke();

                //Restore the rendering context state
                ctx.restore();
            }
        }
    });

    var xAxesLabelMaxLength = 100;

    if(data.xAxisGroupLabels !== undefined && data.xAxisGroupLabels.length > 12){
        xAxesLabelMaxLength = 12;
    }

    const options = {
        responsive: true,
        aspectRatio: 2,
        legend: {
            position: 'top',
            fontSize: fontSize,
            display: datasets.length > 1 ? true : false
        },
        title: {
            display: false,
            text: ''
        },
        layout: {
            padding: {
                left: 10,
                right: 10,
                bottom: 10,
                top: 10
            }
        },
        scales: {
            xAxes: [{
                scaleLabel: {
                    display: true,
                    labelString: data.xAxisLabel,
                    fontSize: fontSize + 4,
                },
                ticks: {
                    fontSize: fontSize,
                    padding: 20,
                    callback: function(value) { // Truncate xAxis Labels
                        if (value.length > xAxesLabelMaxLength) {
                            return value.substring(0, xAxesLabelMaxLength) + '...';
                         }
                         return value;
                    },
                },
                gridLines: {
                    drawBorder: true,
                    display: true,
                    drawOnChartArea: true,
                    tickMarkLength: 0,
                    color: "#EAF0F4"
                }
            }],
            yAxes: [{
                scaleLabel: {
                    display: true,
                    labelString: data.yAxisLabel,
                    fontSize: fontSize + 4,
                },
                ticks: {
                    fontSize: fontSize,
                    padding: 20,
                    min: 0,
                    suggestedMax:suggestedMax
                },
                gridLines: {
                    drawBorder: true,
                    display: true,
                    drawOnChartArea: true,
                    tickMarkLength: 0,
                    color: "#EAF0F4"
                }
            }]
        },
        tooltips: {
            enabled: true,
            mode: 'label',
            callbacks: { // Custom tool tip, otherwise the truncated label is used
                title: function(tooltipItems, data) {
                    var idx = tooltipItems[0].index;
                    return data.labels[idx];
                }
            }
        },
        onClick: function (e) {
            if( this.getElementsAtEvent(e)[0] !== null && this.getElementsAtEvent(e)[0] !== undefined){
                var activePointIndex = this.getElementsAtEvent(e)[0]._index;
                if(onClickBar !== null && onClickBar !== undefined){
                    onClickBar(activePointIndex);
                }
            }
        }
    };

    if ((undefined !== actualMax) && (null !== actualMax)) {
        options.scales.yAxes[0].ticks.max = actualMax;
    }

    // Only create the chart object once
    if (chart[canvasName] === null || chart[canvasName] === undefined) {
        // eslint-disable-next-line no-undef
        chart[canvasName] = new Chart(canvas, {
            type: 'bar',
            data: barChartData,
            options: options
        });
    } else {
        chart[canvasName].data = barChartData;
        chart[canvasName].options = options;
        chart[canvasName].update();
    }
}

function clear(canvasName){
    if (chart[canvasName] !== null && chart[canvasName] !== undefined) {
        chart[canvasName].clear();
        chart[canvasName] = null;
    }
}